import React from "react"
import "./FirstView.scss"
import { StaticImage } from "gatsby-plugin-image"
import { Player } from "@lottiefiles/react-lottie-player"
import DecoLine01 from "@lotties/deco-line01.json"
import DecoLine02 from "@lotties/deco-line02.json"
import DecoLine03 from "@lotties/deco-line03.json"
import DecoLineShort01 from "@lotties/deco-line01-short.json"
import DecoLineShort02 from "@lotties/deco-line02-short.json"
import DecoLineShort03 from "@lotties/deco-line03-short.json"

const FirstView = () => {
  return (
    <div className="first-view">
      <div className="first-view-inner">
        <h1 className="first-view-logo">
          <a href={`${__PATH_PREFIX__}/`} data-gtm-click="firstView-logo">
            <StaticImage
              src="../../images/logo.png"
              layout="fullWidth"
              alt="Mirai Magical School Winter Festival"
            />
          </a>
        </h1>
        <div className="first-view-img-sp">
          <StaticImage src="../../images/kv-sp.jpg" alt="V4Mirai Talents" />
        </div>
        <div className="first-view-img-pc">
          <StaticImage src="../../images/kv-pc.jpg" alt="V4Mirai Talents" />
        </div>
        <h2 className="section-title first-view-title">
          December 21-22
          <br className="sp-break" />
          Live on YouTube
        </h2>
        <div className="first-view-ornament">
          <p className="first-view-text">
            Welcome to V4Mirai Winter Event 2024
          </p>
          <div className="barcode">
            <StaticImage
              src="../../images/icon/icn-barcode.svg"
              layout="fullWidth"
              alt=""
            />
          </div>
          <div className="first-view-ornament-img1">
            <StaticImage
              src="../../images/icon/snow-flake/snowflake01-fv.png"
              alt=""
            />
          </div>
          <div className="first-view-ornament-img2">
            <StaticImage
              src="../../images/icon/snow-flake/snowflake02-fv.png"
              alt=""
            />
          </div>
          <div className="first-view-ornament-img3">
            <StaticImage
              src="../../images/icon/snow-flake/snowflake03-fv.png"
              alt=""
            />
          </div>
          <div className="first-view-ornament-img4">
            <StaticImage
              src="../../images/icon/snow-flake/snowflake04-fv.png"
              alt=""
            />
          </div>
          <Player
            className="deco-line1-sp"
            autoplay
            loop
            src={DecoLineShort01}
          />
          <Player
            className="deco-line2-sp"
            autoplay
            loop
            src={DecoLineShort02}
          />
          <Player
            className="deco-line3-sp"
            autoplay
            loop
            src={DecoLineShort03}
          />
          <Player className="deco-line1" autoplay loop src={DecoLine01} />
          <Player className="deco-line2" autoplay loop src={DecoLine02} />
          <Player className="deco-line3" autoplay loop src={DecoLine03} />
        </div>
      </div>
    </div>
  )
}

export default FirstView
